const configuredUrl = process.env.REACT_APP_FRONTEND_URL;

if (!configuredUrl) {
    throw new Error("REACT_APP_FRONTEND_URL non configurata");
}

export const PUBLIC_SITE_URL = configuredUrl.replace(/\/$/, "");

export const publicUrl = (path = "") => {
    if (!path) return PUBLIC_SITE_URL;
    return `${PUBLIC_SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

export const canonicalPublicUrl = (value = "") => {
    if (!value) return "";
    try {
        const parsed = new URL(value, PUBLIC_SITE_URL);
        return publicUrl(`${parsed.pathname}${parsed.search}${parsed.hash}`);
    } catch {
        return "";
    }
};